import { render, staticRenderFns } from "./ModalPublishItem.vue?vue&type=template&id=6f6bbe5c&scoped=true"
import script from "./ModalPublishItem.vue?vue&type=script&lang=js"
export * from "./ModalPublishItem.vue?vue&type=script&lang=js"
import style0 from "./ModalPublishItem.vue?vue&type=style&index=0&id=6f6bbe5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6bbe5c",
  null
  
)

export default component.exports